import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppShell } from "./shell/AppShell";
import { DetailPage } from "./pages/DetailPage";
import { HealthPage } from "./pages/HealthPage";
import { InboxPage } from "./pages/InboxPage";
import { NewAnfragePage } from "./pages/NewAnfragePage";
import {
  StammdatenIndex,
  StammdatenLayout,
} from "./pages/StammdatenPage";
import { ArtikelPage } from "./pages/stammdaten/ArtikelPage";
import { CatalogPage } from "./pages/stammdaten/CatalogPage";
import { KonditionenPage } from "./pages/stammdaten/KonditionenPage";
import { KundenPage } from "./pages/stammdaten/KundenPage";
import { TenantConfigPage } from "./pages/stammdaten/TenantConfigPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/anfragen" replace /> },
      { path: "anfragen", element: <InboxPage /> },
      { path: "anfragen/neu", element: <NewAnfragePage /> },
      { path: "anfragen/:anfrageId", element: <DetailPage /> },
      {
        path: "stammdaten",
        element: <StammdatenLayout />,
        children: [
          { index: true, element: <StammdatenIndex /> },
          { path: "catalog", element: <CatalogPage /> },
          { path: "kunden", element: <KundenPage /> },
          { path: "artikel", element: <ArtikelPage /> },
          { path: "konditionen", element: <KonditionenPage /> },
          { path: "tenant-config", element: <TenantConfigPage /> },
        ],
      },
      { path: "health", element: <HealthPage /> },
    ],
  },
]);
